import { render } from "./manage-withdrawal-request.vue?vue&type=template&id=40daa604"
import script from "./manage-withdrawal-request.vue?vue&type=script&lang=js"
export * from "./manage-withdrawal-request.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__